@if (items?.length) {
  <div class="items-list-container">
    <mat-list>
      <!-- list header -->
      <mat-list-item>
        <div class="item-container">
          <p class="column name header">Item Name</p>
          <p class="column header">Expected Quantity</p>
          <p class="spacer header"></p>
          <p class="column actions header">Actions</p>
        </div>
      </mat-list-item>
      <!-- end list header -->
      @for (item of items; track item; let i = $index) {
        <mat-list-item
          [ngClass]="getSelectedItemClass(item)"
          (click)="openDetails(item, $event)"
          >
          <div class="item-container" @fadeAnimation>
            <p class="column name">
              {{ item.name }}
            </p>
            <p class="column">{{ getQuantityAndUnitFormatted(item) }}</p>
            <p class="spacer"></p>
            @if (!config.isReadOnly) {
              <div class="column actions">
                <div class="speed-dial-menu-actions"></div>
                <button
                  [matMenuTriggerFor]="menu"
                  (click)="moreOptionsClick($event)"
                  mat-icon-button
                  >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button (click)="editItem(item, i, $event)" mat-menu-item>
                    <mat-icon matTooltip="Edit Item">edit_outline</mat-icon>
                    <span>Edit Item</span>
                  </button>
                  @if (config.allowDelete || creationMode()) {
                    <button
                      (click)="deleteItem(item, i, $event)"
                      mat-menu-item
                      >
                      <mat-icon matTooltip="Delete">delete_outline</mat-icon>
                      <span>Delete item</span>
                    </button>
                  }
                </mat-menu>
                @if (!creationMode()) {
                  <button
                    (click)="openDetails(item, $event)"
                    mat-icon-button
                    >
                    <mat-icon matTooltip="View">chevron_right</mat-icon>
                  </button>
                }
              </div>
            }
            <mat-divider></mat-divider>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </div>
} @else {
  <div id="empty-items">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    You haven't added any item yet.
  </div>
}

